import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';

import deviceTypesService from './deviceTypesService';

export const getIsSettingHolderRelated = (deviceType, settingType) => {
    const isMono = deviceTypesService.isMono(deviceType);

    if (settingType === AEM_DEVICE_SETTINGS_TYPES.ILLUMINATION_MODE) return false;

    // TODO: add more logic based on settingType
    return !isMono;
};
